import Message from '@/lib/message';

let numberOfInstallments = null;
let downPaymentValue = null;

export default {
  checkoutCustomConfig: {
    appClass: { zoom: true },
    confirmButtom: true,
    confirmText: 'Pagar parcelado no boleto',
    showCCBText: true,
  },
  preQualifyEventHandler: {
    onReady() {
      Message.post({ ev: 'ready' });
    },
    onSendPreQualifyId(data) {
      Message.post({ ev: 'sendPreQualifyId', data });
    },
    onError() {
      Message.post({ ev: 'error' });
    },
    onVerify(data) {
      Message.post({ ev: 'verifyCredit', data });
    },
    onGoToCheckout() {
      Message.post({ ev: 'modalGoToCheckout' });
    },
    onClosed() {
      Message.post({ ev: 'modalClose' });
    },
    onResize(data) {
      Message.post({ ev: 'setIframeHeight', data });
    },
  },
  checkoutEventHandler: {
    onReady() {
      Message.post({ ev: 'ready' });
    },
    onError() {
      Message.post({ ev: 'error' });
    },
    onShippingChanged({ downPaymentOptions,
      downPaymentOptionSelected,
      installmentOptionSelected,
      isApproved }) {
      if (isApproved) {
        Message.post({ ev: 'shippingChangedOk', data: { downPaymentOptions, downPaymentOptionSelected, installmentOptionSelected } });
      }
    },
    onCheckoutDataChanged() {
      Message.post({ ev: 'checkoutDataChangedOk', data: { result: 'ok' } });
    },
    onDownPaymentChanged({ downPayment }) {
      Message.post({ ev: 'downPaymentChanged', data: downPayment });

      const newDPValue = downPayment.downPaymentValue;
      if (downPaymentValue !== newDPValue) {
        downPaymentValue = newDPValue;
        Message.post({
          ev: 'changeDownPayment',
          data: downPaymentValue,
        });
      }
    },
    onInstallmentChanged({ installment }) {
      console.log('installment', installment);
      Message.post({ ev: 'installmentChanged', data: installment });

      const newNumberOfInstallments = installment && installment.numberOfInstallments;
      if (numberOfInstallments !== newNumberOfInstallments) {
        numberOfInstallments = newNumberOfInstallments;
        Message.post({
          ev: 'changeParcel',
          data: numberOfInstallments,
        });
      }
    },
    onOptionsChanged({ options }) {
      const { result } = options;
      Message.post({ ev: result.toLowerCase(), data: options });
      if (result === 'APPROVED') {
        Message.post({
          ev: 'cbCheckCredit',
          data: 'aprovado',
        });
      } else {
        Message.post({
          ev: 'repproved',
        });
      }
    },
    onPay({
      downPaymentOptionSelected,
      installmentOptionSelected,
    }) {
      Message.post({ ev: 'pay',
        data: {
          downPaymentOptionSelected,
          installmentOptionSelected,
        },
      });
    },
    onWindowResize({ width, height }) {
      Message.post({ ev: 'resize', data: { width, height } });
    },
  },
};
